import { useEffect, useState } from 'react';
import { SingleTrimSpec } from '../../../services/vehicle-data-service/vehicle-data-service.types';
import { EligibleModelData } from '../use-dyf-eligible-model/use-dyf-eligible-model';
import {
    stringifyVehicleTrim,
    useTrimsAndSpecs,
} from '../use-trims-and-specs/use-trims-and-specs';

export const useTrimSpecSelector = (
    vehicleYmmGroup: EligibleModelData | null,
    flow: 'ymm' | 'vin'
) => {
    const [selectedTrim, setSelectedTrim] = useState<string | null>(null);
    const [selectedSpecs, setSelectedSpecs] = useState<SingleTrimSpec[]>([]);
    const [executeTrimSpecQuery, { data: trimSpecData }] = useTrimsAndSpecs();

    const [trimDescriptionList, setTrimDescriptionList] = useState<string[]>(
        []
    );
    useEffect(() => {
        if (
            flow === 'ymm' &&
            vehicleYmmGroup &&
            vehicleYmmGroup.eligibleFeatureGuide
        ) {
            executeTrimSpecQuery({
                marketingModelYear: `${vehicleYmmGroup.modelYear}`,
                nameplate: vehicleYmmGroup.modelAlias,
            });
        }
    }, [vehicleYmmGroup, flow]);

    useEffect(() => {
        if (trimSpecData?.trims && trimDescriptionList.length == 0)
            setTrimDescriptionList(
                trimSpecData.trims.map(o => o.trimDescription)
            );
    }, [trimSpecData]);

    const handleTrimDropdownChange = (value: string) => {
        setSelectedTrim(value);
        const specsToUse =
            trimSpecData?.vehicleSpec[stringifyVehicleTrim(value)];
        setSelectedSpecs(specsToUse || []);
    };

    return {
        selectedTrim,
        selectedSpecs,
        handleTrimDropdownChange,
        trimSpecData,
        trimDescriptionList,
    };
};
